import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ContactView from '@/views/ContactView.vue'
import AboutUsView from '@/views/AboutView.vue'
import ProductsView from '@/views/ProductsView.vue'
import ComingSoon from '@/views/UnderConstruction.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about-us',
    name: 'about-us',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AboutUsView
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductsView
  },
  {
    path: '/contact-us',
    name: 'Contact',
    component: ContactView
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: ComingSoon,
    beforeEnter: (to, from, next) => {
      if (to.path === '/sitemap.xml') {
        // Let the browser request it directly
        window.location.href = '/sitemap.xml';
      } else {
        next();
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
